import { useLayoutAppKind } from "@ui/layouts/layoutProvider";
import { RecentQuestionLink } from "@ui/layouts/RecentQuestionLink";
import { For, Show } from "solid-js";
import {
	type QuestionStep,
	seedQuestionActivity,
	useQuestionActivityFeed,
} from "~/modules/shared/utils/questionActivity";
import { MenuSubHeading } from "./MenuSubHeading";

export type RecentQuestionItem = {
	id: string;
	prompt: string;
	summary?: string | null;
	name?: string | null;
	tooltip?: string | null;
	href?: string;
	progress?: QuestionStep | null;
};

type Props = {
	class?: string;
	questions?: RecentQuestionItem[];
	viewAllHref?: string;
};

declare const pageVars: {
	recentQuestions?: Array<{
		id: string;
		prompt: string;
		summary?: string;
		name?: string;
		tooltip?: string;
		progress?: QuestionStep | null;
	}>;
};

export const RecentQuestions = (props: Props) => {
	const appKind = useLayoutAppKind();
	const defaultBase = () =>
		appKind === "agency-hub" ? "/roster/questions" : "/studio/questions";
	const questions = () => props.questions ?? pageVars.recentQuestions ?? [];
	const viewAllHref = () => props.viewAllHref ?? defaultBase();
	const hrefFor = (question: RecentQuestionItem) =>
		question.href ?? `${defaultBase()}/${question.id}`;
	seedQuestionActivity(questions());
	useQuestionActivityFeed();

	return (
		<section class={`recent-questions-menu ${props.class ?? ""}`.trim()}>
			<MenuSubHeading
				label="Recent"
				link={viewAllHref()}
				linkLabel="View all"
			/>
			<Show when={questions().length > 0}>
				<ul>
					<For each={questions()}>
						{(question) => (
							<RecentQuestionLink
								questionId={question.id}
								href={hrefFor(question)}
								prompt={question.prompt}
								summary={question.summary ?? undefined}
								tooltip={question.tooltip ?? question.name ?? undefined}
							/>
						)}
					</For>
				</ul>
			</Show>
		</section>
	);
};
